import React from 'react';
import {
  Building2, Wheat, User, Package, Map, Cable, Radio, CheckCircle2,
} from 'lucide-react';

interface OnboardingStepperProps {
  step: number;
  stepLabels: string[];
  ariaLabel: string;
}

const STEP_ICONS = [
  Building2, Wheat, User, Package, Map, Cable, Radio, CheckCircle2,
];

const OnboardingStepper: React.FC<OnboardingStepperProps> = ({ step, stepLabels, ariaLabel }) => {
  return (
    <ol
      className="flex items-center px-6 py-4 gap-2 border-b border-[var(--border-light)] list-none overflow-x-auto"
      aria-label={ariaLabel}
    >
      {stepLabels.map((label, i) => {
        const Icon = STEP_ICONS[i];
        const active = i === step;
        const done = i < step;
        return (
          <li
            key={label}
            className="flex items-center gap-2 flex-1 last:flex-none min-w-0"
            aria-current={active ? 'step' : undefined}
            data-testid={`onboarding-step-${i}`}
          >
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center text-sm shrink-0 ${
                active
                  ? 'bg-[var(--color-primary)] text-white'
                  : done
                    ? 'bg-[var(--color-success)]/15 text-[var(--color-success)]'
                    : 'bg-[var(--gray-100)] text-[var(--text-tertiary)]'
              }`}
            >
              <Icon className="w-4 h-4" aria-hidden="true" focusable="false" />
            </div>
            {/* R1A-05: Step label always accessible — sr-only on mobile, visible from sm */}
            <span
              className={`text-xs ${active ? 'text-[var(--color-primary)] font-medium' : 'text-[var(--text-secondary)]'}`}
            >
              <span className="sr-only sm:not-sr-only">{label}</span>
            </span>
            {i < stepLabels.length - 1 && (
              <div className="flex-1 h-px bg-[var(--border-light)] min-w-[8px]" aria-hidden="true" />
            )}
          </li>
        );
      })}
    </ol>
  );
};

export default OnboardingStepper;
